import { useTenantConfig } from '../../context/TenantConfigContext'
import HeaderHorizontal from './HeaderHorizontal'
import HeaderCentered from './HeaderCentered'
import HeaderStacked from './HeaderStacked'

const HEADER_REGISTRY = {
  'header-horizontal': HeaderHorizontal,
  'header-centered': HeaderCentered,
  'header-stacked': HeaderStacked,
  'header-default': HeaderHorizontal,
  HEADER_CLASSIC: HeaderHorizontal,
  HEADER_HORIZONTAL: HeaderHorizontal,
  HEADER_DEFAULT: HeaderHorizontal,
  HEADER_CENTERED: HeaderCentered,
  HEADER_STACKED: HeaderStacked,
  HEADER_LEFT: HeaderStacked,
  default: HeaderHorizontal,
}

function DynamicHeader() {
  const { config, getComponentKey } = useTenantConfig()
  const key = getComponentKey('header')
  const HeaderComponent = HEADER_REGISTRY[key] ?? HeaderHorizontal

  return <HeaderComponent brand={config?.brand} headerNav={config?.headerNav} />
}

export default DynamicHeader
